import { Check } from "lucide-react";
import { PERCORSI } from "@/config/site";
import { goToForm } from "@/lib/prefill";

export const Percorsi = () => (
  <section className="bg-warm py-20 lg:py-28" data-testid="percorsi-section">
    <div className="container-ph">
      <div className="reveal max-w-2xl">
        <span className="gold-line mb-5" />
        <h2 className="h-section">Due percorsi, un unico obiettivo</h2>
      </div>
      <div className="mt-14 space-y-16 lg:space-y-24">
        {PERCORSI.map((p, idx) => (
          <section id={p.id} key={p.id} className="grid gap-10 lg:grid-cols-12 lg:gap-14 items-start" data-testid={`percorso-${p.id}`}>
            <div className={`reveal lg:col-span-5 ${idx % 2 ? "lg:order-2" : ""}`}>
              <div className="relative overflow-hidden">
                <img src={p.image} alt={p.alt} loading="lazy" className="w-full aspect-[4/3] object-cover" />
                <span className="absolute left-0 top-6 bg-forest text-ivory text-[11px] font-semibold tracking-[0.2em] px-4 py-2">{p.kicker}</span>
              </div>
            </div>
            <div className={`reveal reveal-delay-1 lg:col-span-7 ${idx % 2 ? "lg:order-1" : ""}`}>
              <h3 className="font-serif text-3xl sm:text-4xl text-forest" data-testid={`percorso-${p.id}-title`}>{p.title}</h3>
              <p className="mt-3 text-base sm:text-lg text-ink/75">{p.subtitle}</p>
              <ul className="mt-8 grid gap-x-8 gap-y-2.5 sm:grid-cols-2">
                {p.items.map((it) => (
                  <li key={it} className="check-item"><Check size={16} className="mt-1 shrink-0 text-bronze" />{it}</li>
                ))}
              </ul>
              <button className="btn-primary mt-9" onClick={() => goToForm(p.prefill)} data-testid={`percorso-${p.id}-button`}>{p.button}</button>
            </div>
          </section>
        ))}
      </div>
    </div>
  </section>
);
